<template>
  <el-dialog :title="title" :visible.sync="open" :before-close="close" :append-to-body="true" width="700px">
    <div class="form-group-container">
      <div class="form-group">
        <label>Name</label>
        <div class="container">
          <el-input v-model="library.name[lang]" @keyup.enter.native="save">{{ library.name[lang] }}</el-input>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" plain >{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="save" >{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'library-form',
  props: {
    id: {
      type: String,
      required: false
    },
    open: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      library: {}
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    title () {
      if (this.id) {
        return 'Edit a library'
      } else {
        return 'Create a library'
      }
    }
  },
  watch: {
    site: function (site) {
      this.init()
    }
  },
  methods: {
    ...mapActions('libraries', ['addLibrary']),
    init () {
      if (this.site) {
        if (this.id) {
          this.library = Object.assign({}, this.getById(this.id))
        } else {
          this.library = {
            name: {}
          }
        }
        this.library.idSite = this.site.id
      }
    },
    save () {
      this.addLibrary({library: this.library}).then(() => {
        this.$notify({
          title: 'Success',
          message: this.$root.$t('notifications.library.added'),
          type: 'success'
        })
        this.close()
      }).catch((response) => {
        this.$notify.error({
          title: this.$root.$t('api.' + response.code + '.title'),
          message: this.$root.$t('api.' + response.code + '.message')
        })
      })
    },
    close () {
      this.$emit('close')
    }
  },

  created () {
    this.init()
  }
}

</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/libraries/library-form.vue